var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('p',[_vm._v("欢迎使用美游美在线客服，如有任何疑问请点击右下角咨询按钮。")]),_c('CustomerService')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }